import { useState } from "react";

import ExcelUploadForm from "./components/ExcelUploadForm";
import UploadSummary from "./components/UploadSummary";
import UploadErrorList from "./components/UploadErrorList";
import UploadHistory from "./components/UploadHistory";

import { useGetQuizzesQuery } from "../../slices/quizApiSlice";
import { useGetSubjectsQuery } from "../../slices/subjectApiSlice";

import "./styles/excelUpload.css";

const ExcelUploadScreen = () => {
  const [uploadResult, setUploadResult] = useState(null);
  const [refreshHistory, setRefreshHistory] = useState(0);

  /*
  ==========================================
  Load Quiz List
  ==========================================
  */
  const {
    data: quizzes = [],
    isLoading: quizzesLoading,
    error: quizzesError,
  } = useGetQuizzesQuery();

  /*
  ==========================================
  Load Subject List
  ==========================================
  */
  const {
    data: subjects = [],
    isLoading: subjectsLoading,
    error: subjectsError,
  } = useGetSubjectsQuery();

  const handleUploadSuccess = (response) => {
    setUploadResult(response);
    setRefreshHistory((previous) => previous + 1);
  };

  const isLoading = quizzesLoading || subjectsLoading;

  const loadError =
    quizzesError?.data?.message ||
    subjectsError?.data?.message ||
    quizzesError?.error ||
    subjectsError?.error;

  return (
    <div className="excel-upload-page">
      <div className="page-header">
        <h1>Upload Questions Excel</h1>

        <p>
          Upload questions to the Question Bank or directly to a Quiz using an
          Excel file.
        </p>
      </div>

      <div className="upload-card">
        {isLoading ? (
          <p>Loading data...</p>
        ) : loadError ? (
          <div className="error-message">{loadError}</div>
        ) : (
          <ExcelUploadForm
            quizzes={quizzes}
            subjects={subjects}
            onUploadSuccess={handleUploadSuccess}
          />
        )}
      </div>

      {uploadResult && (
        <>
          <UploadSummary result={uploadResult} />

          {uploadResult.upload?.errorMessages?.length > 0 && (
            <UploadErrorList errors={uploadResult.upload.errorMessages} />
          )}
        </>
      )}

      <div className="history-card">
        <UploadHistory refreshKey={refreshHistory} />
      </div>
    </div>
  );
};

export default ExcelUploadScreen;
